"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("leaflet/dist/leaflet.css");
const react_leaflet_1 = require("react-leaflet");
const datasetContext_1 = __importDefault(require("../context/dataset/datasetContext"));
const jsonpath_1 = __importDefault(require("jsonpath"));
const mauritania_geojson_1 = __importDefault(require("../utils/data/mauritania-geojson"));
const helper_1 = require("../utils/helper");
const center = [21.0078589, -10.951734];
const labels = [
    "Hodh Echargui",
    "Hodh El Garbi",
    "Assaba",
    "Gorgol",
    "Brakna",
    "Trarza",
    "Adrar",
    "Nouadhibou",
    "Tagant",
    "Guidimagha",
    "Tiris Zemour",
    "Inchiri",
    "Nouakchott",
];
const dataChart = {
    labels: labels,
    datasets: [
        {
            label: "Support à l'apprentissage",
            backgroundColor: "rgb(255, 99, 132)",
            data: [],
        },
    ],
};
let locationArray = [
    { properties: { index: 0, abbreviation: "HC", value: 0 } },
    { properties: { index: 1, abbreviation: "HG", value: 0 } },
    { properties: { index: 2, abbreviation: "AS", value: 0 } },
    { properties: { index: 3, abbreviation: "GO", value: 0 } },
    { properties: { index: 4, abbreviation: "BR", value: 0 } },
    { properties: { index: 5, abbreviation: "TR", value: 0 } },
    { properties: { index: 6, abbreviation: "AD", value: 0 } },
    { properties: { index: 7, abbreviation: "DN", value: 0 } },
    { properties: { index: 8, abbreviation: "TG", value: 0 } },
    { properties: { index: 9, abbreviation: "GD", value: 0 } },
    { properties: { index: 10, abbreviation: "TZ", value: 0 } },
    { properties: { index: 11, abbreviation: "IN", value: 0 } },
    { properties: { index: 12, abbreviation: "NO", value: 0 } },
];
const GeoChart = ({ selectedDataset, selectedTable }) => {
    const [onselect, setOnselect] = (0, react_1.useState)(null);
    const datasetContext = (0, react_1.useContext)(datasetContext_1.default);
    const { jsonDataByIdList } = datasetContext;
    const [geoJson, setGeoJson] = (0, react_1.useState)(null);
    const selectedTableIndex = jsonDataByIdList.findIndex((i) => {
        return i.id === selectedTable;
    });
    (0, react_1.useEffect)(() => {
        if (selectedDataset !== "" && selectedTableIndex !== -1) {
            let jsonObj = jsonpath_1.default.query(JSON.parse(jsonDataByIdList[selectedTableIndex].json_data), `$..["${selectedDataset}"]`)[0];
            let wilayaList = jsonpath_1.default.query(jsonObj, `$..["Wilaya"]`)[0];
            if (wilayaList == null) {
                wilayaList = jsonpath_1.default.query(jsonObj, `$..["wilaya"]`)[0];
            }
            if (wilayaList == null) {
                wilayaList = jsonpath_1.default.query(jsonObj, `$..["Région"]`)[0];
            }
            if (wilayaList == null) {
                wilayaList = jsonpath_1.default.query(jsonObj, `$..["région"]`)[0];
            }
            if (wilayaList != null) {
                let length = wilayaList.length;
                if (length <= 13) {
                    for (let i = 0; i < length; i++) {
                        const label = Object.keys(wilayaList[i])[0];
                        const value = wilayaList[i][label];
                        locationArray[i].properties.value = value;
                    }
                    const geoJsonFeatures = (0, helper_1.mergeGeoJson)(mauritania_geojson_1.default, locationArray);
                    setGeoJson(geoJsonFeatures);
                }
                else {
                    setGeoJson(null);
                }
            }
            else {
                setGeoJson(null);
            }
        }
    }, [selectedDataset]);
    function highlightFeature(e) {
        let layer = e.propagatedFrom;
        const { name, value } = layer.feature.properties;
        setOnselect({ name: name, value: value });
        layer.setStyle({
            weight: 5,
            color: "#666",
            dashArray: "",
            fillOpacity: 0.7,
        });
    }
    const confirmedStyle = (feature) => {
        let value = feature.properties.index;
        return {
            fillColor: (0, helper_1.getColor)(value),
            fillOpacity: 0.7,
            stroke: false,
        };
    };
    if (geoJson == null) {
        return react_1.default.createElement("div", { className: "w-full h-full flex justify-center items-center flex-1" }, "NO DATA AVAILIBLE");
    }
    const resetHighlight = ({ layer }) => {
        setOnselect(null);
        layer.res({ weight: 2, color: "white", dashArray: "3" });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, selectedDataset !== "" && geoJson != null && (react_1.default.createElement(react_leaflet_1.MapContainer, { center: center, zoom: 6, style: { height: "100%" } },
        react_1.default.createElement(react_leaflet_1.GeoJSON, { data: geoJson, style: confirmedStyle, eventHandlers: {
                mouseover: highlightFeature,
                mouseout: resetHighlight,
            } }),
        react_1.default.createElement("div", { className: "leaflet-right leaflet-top own-leaflet-info" },
            react_1.default.createElement("h4", null, "Donn\u00E9es actuelles"),
            " ",
            react_1.default.createElement("br", null),
            onselect != null && onselect.name != null && onselect.value != null ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("strong", null, onselect.name),
                `: ${onselect.value} `)) : (react_1.default.createElement("strong", null, "Survolez Wilaya")))))));
};
exports.default = GeoChart;
